module.exports = __webpack_public_path__ + "img/gc_country_flag_do.7ce15eec.svg";